import config from "@/lib/config";
import { gql } from "@apollo/client";
import { logicaErrorBody } from "./helper";
import { UserInputError } from "apollo-server-errors";
import { TERMS_ERROR_MESSAGES } from "@/lib/errors";

export const typeDef = gql`
  type Term {
    term_id: ID!
    id_key: String
    display_name: String
    required: Boolean
    current_revision: TermRevision
  }

  type TermRevision @cacheControl(maxAge: 120) {
    term_revision_id: Int
    term_id: Int
    number: Int
    unique_key: String
    url: String
    agreement: TermAgreement
  }

  type TermAgreement @cacheControl(scope: PRIVATE, maxAge: 120) {
    agreement_id: Int
    user_id: Int
    term_id: Int
    term_revision_number: Int
    agreed_at: String
  }

  enum TermType {
    REQUIRED
    OPTIONAL
  }

  type Query {
    terms(keys: [String], withAgreement: Boolean): [Term]
    registTerms(type: TermType!): [Term]
    loginTerms(type: TermType!, cacheMaxAge: Int): [Term]
  }

  type Mutation {
    agree(keys: [String]): [TermRevision]
  }
`;

const termTypeValue = { REQUIRED: "required", OPTIONAL: "optional" };
export const resolvers = {
  Query: {
    terms: async (_parent, { keys, withAgreement }, { dataSources }) => {
      const results = await Promise.all(
        keys.map(async (key) => {
          return await dataSources.terms.getTerm(key, withAgreement);
        })
      );
      return results;
    },
    registTerms: async (_parent, { type }, { dataSources }) => {
      const keys = config.terms.regist["vod"][termTypeValue[type]];
      const results = await Promise.all(
        keys.map(async (key) => {
          return await dataSources.terms.getTerm(key, true);
        })
      );
      return results;
    },
    loginTerms: async (
      _parent,
      { type, cacheMaxAge },
      { req, res, dataSources },
      info
    ) => {
      if (typeof cacheMaxAge === "number") {
        info.cacheControl.setCacheHint({ maxAge: cacheMaxAge });
      }

      const keys = config.terms.login["vod"][termTypeValue[type]];

      let userRightIds;
      if (keys.includes("valueplan_term")) {
        userRightIds = await dataSources.user.rightIds();
      }
      const filteredKeys = keys.filter((key) => {
        // ベーシックパックを購入していなければベーシックパックを外す
        if (key === "valueplan_term") {
          return userRightIds.includes(config.valuePlan.rightId);
        }
        return true;
      });

      const results = await Promise.all(
        filteredKeys.map(async (key) => {
          return await dataSources.terms.getTerm(key, true);
        })
      );

      return results;
    },
  },

  Mutation: {
    agree: async (_parent, { keys }, { dataSources }) => {
      try {
        const results = await Promise.all(
          keys.map(async (key) => {
            return dataSources.terms.agree(key);
          })
        );
        return results.flatMap((result) => result.term_revisions);
      } catch (e) {
        console.log("terms agree error", e);
        const body = logicaErrorBody(e);
        const errorCode = body?.error?.code;
        if (errorCode === 11007) {
          throw new UserInputError(TERMS_ERROR_MESSAGES["optOut"]);
        }
      }
    },
  },
  Term: {
    required: (term) => {
      const requiredKeys = [
        ...config.terms.regist.vod.required,
        ...config.terms.login.vod.required,
      ];
      return requiredKeys.includes(term.id_key);
    },
  },
};
